import React, {Component} from "react";
import PropTypes from "prop-types";

class PageTitle extends Component {
	static defaultProps = {
		text : ''
	};

	static propTypes = {
		text : PropTypes.string.isRequired,
	};

	render() {
		return (
			<div className="page__title">{this.props.text}</div>
		);
	}
}

export default PageTitle;


// WEBPACK FOOTER //
// ./src/app/pages/Page/PageTitle.js